var DialogAlertModule = /** @class */ (function () {
    function DialogAlertModule() {
    }
    return DialogAlertModule;
}());
export { DialogAlertModule };
